import React, { Component } from "react";
import {
    Row,
    Col,
    Form,
    message,
    Space
} from "antd";
import Button from '@mui/material/Button';
import { backendGet, backendPostWithoutRefresh } from "../../../helpers/callBackend";
import GenerateCode from "../../formItems/generateCode";

class VirtualDebitCardDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            getNewToken: this.props.cardDetails.get_new_token,
            verificationToken: '',
            verificationCode: '',
            vaultId: props.cardDetails.vgs_vault_id,
            customerToken: props.cardDetails.customer_token,
            cardId: props.cardDetails.card_id,
            loadingCardDetails: true,
            cardExpiration: '',
            cardholderName: '',
        };
    };

    componentDidMount = () => {
        if (!this.state.getNewToken) {
            this.fetchCardDetails();
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevState.customerToken !== this.state.customerToken) {
            this.fetchCardDetails();
        }
    }

    fetchCardDetails = async () => {
        message.info("Retrieving card details...");
        const VGSShow = window.VGSShow;
        const show = VGSShow.create(this.state.vaultId);
        const customerToken = this.state.customerToken;
        const cardId = this.state.cardId;
        const cardNumberIframe = await show.request({
            name: 'data-text',
            method: 'GET',
            path: '/cards/' + cardId + '/secure-data/pan',
            headers: {
                "Authorization": "Bearer " + customerToken
            },
            htmlWrapper: 'text',
            jsonPathSelector: 'data.attributes.pan'
        });
        cardNumberIframe.render('#cardNumber');
        const cardCVVIframe = await show.request({
            name: 'data-text',
            method: 'GET',
            path: '/cards/' + cardId + '/secure-data/cvv2',
            headers: {
                "Authorization": "Bearer " + customerToken
            },
            htmlWrapper: 'text',
            jsonPathSelector: 'data.attributes.cvv2'
        });
        cardCVVIframe.render('#cvv2');
        if (this.state.loadingCardDetails) {
            backendGet(
                this,
                "/api/bank-account/virtual-debit-card/",
                { params: { bank_account_id: this.props.bankAccountId } },
                "loadingCardDetails",
                (s, d) => {                
                    s['cardExpiration'] = d['attributes']['expirationDate'];
                    s['cardholderName'] = `${d['attributes']['fullName']['first']} ${d['attributes']['fullName']['last']}`;
                    return s;
                }
            );
        }
    }

	handleVerificatonCode = async (values) => {
		this.setState({ ...this.state, verificationToken: values.verificationToken, verificationCode: values.verificationCode  });
	};

    onFormSubmitModal = async (values) => {
        let response = await backendPostWithoutRefresh(
            "/api/bank-account/virtual-debit-card/token/",
            {
                'verificationToken': this.state.verificationToken,
                'verificationCode': values['verificationCode'],
                'bank_account_id': this.props.bankAccountId,
            },
        );
        this.setState({
            customerToken: response.data["customer_token"],
            getNewToken: response.data['get_new_token'],
        });
    };

    render() {
        return (
            <>
                {(this.state.getNewToken) ? (
                    <Form
                        layout="vertical"
                        name="basic"
                        onFinish={this.onFormSubmitModal}
                        autoComplete="off"
                    >
                        <Row style={{ marginLeft: "10px" }}>
                            <h4 style={{ marginBottom: "30px" }}>Enter the code to see the virtual debit card details.</h4>
                            <GenerateCode
                                bankAccountId={this.props.bankAccountId}
                                onChange={this.handleVerificatonCode}
                            />
                        </Row>

                        <Form.Item>
                            <Button
                                htmlType="submit"
                                disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                                style={{ margin: "3px", width: "100%" }}
                                sx={{ fontSize: 14, textTransform: 'none' }}
                            >
                                Submit
                            </Button>
                        </Form.Item>

                    </Form>
                ) : (
                    <Space direction="vertical">
                        <Row>
                            <p>Cardholder Name</p>
                            <p style={{ marginLeft: "20px" }}>{this.state.cardholderName}</p>
                        </Row>
                        <Row>
                            <Col span={8}>
                                <p>Card Number</p>
                                <div id="cardNumber" ></div>
                            </Col>
                            <Col span={8}>
                                <p>CVV</p>
                                <div id="cvv2" ></div>
                            </Col>
                            <Col span={8}>
                                <p>Expiration Date</p>
                                <p>{this.state.cardExpiration}</p>
                            </Col>
                        </Row>
                    </Space>
                )}
            </>
        );
    }
}

export default VirtualDebitCardDetails;
